/** Fasten CDN logo URL for a given brand */
export const getFastenLogoUrl = (brandId: string) => `https://cdn.fastenhealth.com/logos/sources/${brandId}.png`;

/** Format platform type for display (e.g., "epic" -> "Epic") */
export const formatPlatformName = (platformType: string | undefined) => {
    if (!platformType) return 'Unknown';
    return platformType.charAt(0).toUpperCase() + platformType.slice(1).toLowerCase();
};
